import type { CoreDispatch, CoreRootState } from '../CoreStore';
import { chatActions } from '../slices/chat/slice';
import { ChatType } from '../slices/chat/types';

export const incrementUnreadPrivateMessageCounterAction = () => {
  return (dispatch: CoreDispatch, getState: () => CoreRootState): void => {
    const { chat } = getState();

    if (chat.openedChatType !== ChatType.GameChat) {
      dispatch(chatActions.setUnreadPrivateMessageCounter(chat.unreadPrivateMessageCount + 1));
    }
  };
};
